function UserLock(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="prefix__lucide prefix__lucide-user-lock-icon prefix__lucide-user-lock"
      {...props}
    >
      <path d="M19 16v-2a2 2 0 00-4 0v2M9.5 15H7a4 4 0 00-4 4v2" />
      <circle cx={10} cy={7} r={4} />
      <rect x={13} y={16} width={8} height={5} rx={0.899} />
    </svg>
  )
}

export default UserLock
